import { useEffect, useState } from "react";
import api from "../../../configs/api";
import {
  confirmAction,
  toastError,
  toastSuccess,
} from "../../../utils/confirmAction";
import { useNavigate } from "react-router-dom";
const ApprovalCardSkeleton = () => {
  return (
    <div className="bg-white border border-border rounded-xl p-4 shadow-sm animate-pulse">
      <div className="h-40 w-full bg-gray-200 rounded-lg mb-4"></div>

      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
      <div className="h-3 bg-gray-200 rounded w-2/3 mb-4"></div>

      <div className="flex justify-between mt-3">
        <div className="h-8 w-20 bg-gray-200 rounded-lg"></div>
        <div className="h-8 w-20 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
  );
};

const PropertyApprovalCard = ({ item, onSelect, onApprove, onReject }) => {
  return (
    <div
      className="bg-white border border-border rounded-xl shadow-sm hover:shadow-md transition cursor-pointer overflow-hidden"
      onClick={onSelect}
    >
      {/* Thumbnail */}
      <div className="h-40 w-full">
        <img
          src={item.thumbnail}
          alt=""
          className="h-full w-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-semibold text-text-primary text-base line-clamp-1">
          {item.title}
        </h3>

        <p className="text-sm text-text-secondary mt-1">
          {item.type.charAt(0).toUpperCase() + item.type.slice(1)} •{" "}
          {item.location || "Unknown"}
        </p>

        <p className="text-xs text-text-muted mt-1">
          Listed by: {item?.listedBy?.fullName}
        </p>

        {/* Actions */}
        <div className="flex justify-between mt-4">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onReject(item);
            }}
            className="px-3 py-1.5 bg-status-danger text-white rounded-lg text-sm hover:bg-red-600"
          >
            Reject
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              onApprove(item);
            }}
            className="px-3 py-1.5 bg-status-success text-white rounded-lg text-sm hover:bg-green-600"
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

const PropertyApprovalList = ({ list, loading }) => {
  const [properties, setProperties] = useState(list || []);
  const navigate = useNavigate();

  useEffect(() => {
    setProperties(list);
  }, [list]);

  const handleApprove = async (property) => {
    const confirm = await confirmAction(
      "Approve Property?",
      `This will approve and publish "${property.title}".`,
      "Approve"
    );
    if (!confirm.isConfirmed) return;

    try {
      await api.post(`/approvals/properties/approve/${property.id}`);
      toastSuccess("Property approved!");
      setProperties((prev) => prev.filter((p) => p.id !== property.id));
    } catch (err) {
      console.error(err);
      toastError("Approval failed");
    }
  };

  const handleReject = async (property) => {
    const confirm = await confirmAction(
      "Reject Property?",
      `This will reject "${property.title}".`,
      "Reject"
    );
    if (!confirm.isConfirmed) return;

    try {
      await api.post(`/approvals/properties/reject/${property.id}`, {
        reason: "Incomplete / invalid listing details",
      });

      toastSuccess("Property rejected.");
      setProperties((prev) => prev.filter((p) => p.id !== property.id));
    } catch (err) {
      console.error(err);
      toastError("Rejection failed");
    }
  };

  return (
    <div className="p-4">
      {/* Skeleton Loading */}
      {loading && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {Array.from({ length: 6 }).map((_, i) => (
            <ApprovalCardSkeleton key={i} />
          ))}
        </div>
      )}

      {/* Property Cards */}
      {!loading && properties.length > 0 && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {properties?.map((property) => (
            <PropertyApprovalCard
              key={property.id}
              item={property}
              onSelect={() => navigate(`details/${property.id}`)}
              onApprove={handleApprove}
              onReject={handleReject}
            />
          ))}
        </div>
      )}

      {/* Empty State */}
      {!loading && properties?.length === 0 && (
        <p className="text-center text-text-muted mt-10">
          No pending properties found.
        </p>
      )}
    </div>
  );
};

export default PropertyApprovalList;

// import { useEffect, useState } from "react";
// import ApprovalCard from "./ApprovalCard";

// const mockProperties = [
//   {
//     id: "p1",
//     title: "Skyline Residency Tower 4",
//     typeLabel: "Residential Property",
//     subtitle: "By: Stalin Patel",
//     createdAtFormatted: "11 Dec 2025",
//   },
//   {
//     id: "p2",
//     title: "Utkal Commercial Bay",
//     typeLabel: "Commercial Property",
//     subtitle: "By: Sneha Sharma",
//     createdAtFormatted: "09 Dec 2025",
//   },
// ];

// const PropertyApprovalList = () => {
//   const [list, setList] = useState(mockProperties);
//   const [search, setSearch] = useState("");

//   // API READY
//   // useEffect(() => api.get("/admin/approvals/properties"))

//   const filtered = list.filter((p) =>
//     p.title.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="p-4">
//       <input
//         type="text"
//         placeholder="Search Properties"
//         className="border px-3 py-2 rounded-lg mb-4 w-full"
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//       />

//       <h2 className="text-lg font-semibold mb-3">
//         Property Approvals{" "}
//         <span className="text-sm text-status-danger ml-2">
//           ({filtered.length})
//         </span>
//       </h2>

//       <div className="grid md:grid-cols-2 gap-4">
//         {filtered.map((item) => (
//           <ApprovalCard
//             key={item.id}
//             item={item}
//             onSelect={() => alert("Open Property Details")}
//             onApprove={() => alert("Approve Property")}
//             onReject={() => alert("Reject Property")}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PropertyApprovalList;
